export default "__VITE_ASSET__DRoiM$aL__"